export default {
  title: 'Maksuyhdyskäytävät',
  fields: {
    name: 'Nimi',
    payment_gateway: 'Maksuyhdyskäytävät',
    live_from: 'Käytössä alkaen',
    last_30_days_sales: 'Myynti viim. 30 päivää',
    kyc_deadlines: 'KYC-määräajat',
    actions: 'Toiminnot',
  },
  stats: {
    active_on_stripe: 'Aktiivinen Stripessä',
    active_on_adyen: 'Aktiivinen Adyenissä',
    adyen_verification_pending: 'Adyen-vahvistus odottaa',
  },
  filters: {
    search_placeholder: 'Hae nimellä...',
    gateway_status_placeholder: 'Kaikki yhdyskäytävät',
  },
  not_configured: {
    title: 'Maksuja ei ole vielä määritetty',
    description:
      'Tilillesi ei ole yhdistetty maksupalveluntarjoajaa. Ravintolat voidaan asettaa täysin valmiiksi, mutta ne eivät voi aktivoitua tai vastaanottaa verkkomaksuja ennen kuin maksut on määritetty.',
  },
  gateway_statuses: {
    stripe_as_primary: 'Stripe',
    adyen_as_primary: 'Adyen',
    adyen_pending: 'Adyen (odottaa)',
  },
  gateways: {
    stripe: 'Stripe',
    adyen: 'Adyen',
  },
  verification_statuses: {
    verified: 'Vahvistettu',
    pending: 'Odottaa',
    rejected: 'Hylätty',
  },
  buttons: {
    actions: 'Toiminnot',
    switch_to: 'Vaihda palveluun {{gateway}}',
    view_details: 'Näytä tiedot',
    open_onboarding: 'Avaa käyttöönotto',
    create_onboarding_link: 'Luo käyttöönottolinkki',
  },
  modal: {
    title: 'Vaihda maksuyhdyskäytävää',
    description:
      'Haluatko varmasti vaihtaa yrityksen {{companyName}} yhdyskäytävästä <bold>{{currentGateway}}</bold> yhdyskäytävään <bold>{{targetGateway}}</bold>?',
    not_verified_warning: '{{gateway}} ei ole vahvistettu tälle yritykselle. Maksujen käsittely saattaa häiriintyä.',
    confirm: 'Vaihda',
    cancel: 'Peruuta',
  },
  details_modal: {
    title: '{{companyName}} — Maksuyhdyskäytävän tiedot',
    requirements: 'Vaatimukset',
    no_requirements: 'Ei odottavia vaatimuksia.',
    deadline: 'Määräaika',
    capabilities: 'Ominaisuudet',
    onboarding_links: {
      section_title: 'Käyttöönottolinkki',
      active_link: 'Aktiivinen linkki',
      expires: 'Vanhenee {{date}}',
      create_button: 'Luo linkki',
      extend_button: 'Jatka linkkiä',
      loading: 'Ladataan linkkejä…',
    },
  },
  toasts: {
    onboarding_link_failed: 'Käyttöönottolinkin luonti epäonnistui.',
    switch_success: 'Maksuyhdyskäytävä vaihdettu onnistuneesti.',
    switch_failed: 'Maksuyhdyskäytävän vaihto epäonnistui.',
    failed_to_load_data: 'Tietojen lataaminen epäonnistui.',
  },
};
